import { GetAppointmentOutcome } from '~/domain/usecases/appointment/remote';
import {
  BadRequestError,
  InvalidCredentialsError,
  Forbidden,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';

export class RemoteGetAppointmentOutcome implements GetAppointmentOutcome {
  private readonly url: string;

  private readonly httpCliente: HttpClient<GetAppointmentOutcome.Model>;

  constructor(
    url: string,
    httpClient: HttpClient<GetAppointmentOutcome.Model>,
  ) {
    this.url = url;
    this.httpCliente = httpClient;
  }

  getRecordings = async (
    params: GetAppointmentOutcome.Params,
  ): Promise<GetAppointmentOutcome.Model> => {
    let query = '';
    Object.entries(params).forEach(([key, value]) => {
      if (value) query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpCliente.request({
      url: `${this.url}?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new Forbidden();
    }
  };
}
